import axios from "axios";

const API_URL = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

/**
 * Récupère le statut de livraison transporteur d'une commande.
 * @param {string} orderId
 * @param {string} token - JWT du client
 * @returns {Promise<{ order_id: string, missions: Array }>}
 */
export async function getOrderShipping(orderId, token) {
  const { data } = await axios.get(`${API_URL}/orders/${orderId}/shipping`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

/** Labels lisibles pour le statut transporteur */
export const MISSION_STATUS = {
  available:  { label: "En attente de livreur", color: "blue",   icon: "🕐" },
  accepted:   { label: "Livreur assigné",        color: "amber",  icon: "✅" },
  in_transit: { label: "En route",               color: "violet", icon: "🚚" },
  delivered:  { label: "Livré",                  color: "green",  icon: "✅" },
  cancelled:  { label: "Annulée",                color: "red",    icon: "❌" },
};

/** Retourne true si la commande a au moins un item TRANSPORT ou EXPRESS */
export function hasTransportDelivery(order) {
  return (order?.items || []).some(
    (it) =>
      it.delivery_mode === "TRANSPORT" || it.delivery_mode === "EXPRESS"
  );
}
